import request from '@/utils/request'

function getEventTags() {
    return request({
        url: `/api/activity/tags`,
        method: 'get'
    })
}

function getEvents(tag, offset, length) {
    return request({
        url: `/api/activity/published/${tag}?offset=${offset}&length=${length}`,
        method: 'get'
    })
}

function getEventContent(id) {
    return request({
        url: `/api/activity/${id}`,
        method: 'get'
    })
}

function getAllEvents() {
    return request({
        url: `/api/activity/published`,
        method: 'get'
    })
}

function getSingleMonthEvents({year, month}) {
    return request({
        url: `/api/activity/published/month?year=${year}&month=${month}`,
        method: 'get'
    })
}

export { getEventTags, getEvents, getEventContent, getAllEvents, getSingleMonthEvents }


// WEBPACK FOOTER //
// ./src/api/api_event.js